<script>
    import {link} from 'svelte-spa-router'
    export let href,style,text
</script>

<a style="--mbWidth:{style.width*0.9}px;--base:{style.base};--color: {style.color};--width:{style.width}px;--height:{style.height}px;--border-width:{style.borderWidth}px;" href={href} use:link>    
    {text}
</a>
<style>
    a{
        position: relative;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color:var(--color);
        width:var(--width);
        height:var(--height);
        border:var(--border-width) solid var(--color);
        line-height:var(--height) ;
        text-decoration: none;
        font-family: "Noto Sans JP",sans-serif;
        font-size: 16px;
        background-color: var(--base);
        transition:all .5s;
    }
    a:after{
        content:"→";
    }
    a:hover{
        color:var(--base);
        background-color:var(--color);
        border:var(--border-width) solid var(--base);
        transition:all .5s;
    }
    @media screen and (max-width:640px){
        a{
            width:var(--mbWidth);
        }
    }
</style>